import Vue from "vue";
import fetchData from "./social-media-feed"


var app = new Vue({
    el: '#app-fb',
    data: {
        url_fb: 'https://api.magentateam.pl/api/fb/feeds/1/7dfgf63-k12yrr-pg8m4s-ob88v5',
        url_instagram: 'https://api.magentateam.pl/api/instagram/media/2/7dfgf63-k12yrr-pg8m4s-ob88v5?limit=55',
        list_show: [],
        list_hidden: [],
    },
    created: function () {
        // setVue(this);
    },
    mounted: function(){
        let that = this;

        const posts = [];
        fetchData(this.url_fb, this.url_instagram).then(posts => {

            const facebookPosts = posts.filter(post => post.source === 'facebook');
            const instagramPosts = posts.filter(post => post.source === 'instagram');


            let mixedPosts = [];


            const maxLength = Math.max(facebookPosts.length, instagramPosts.length);
            for (let i = 0; i < maxLength; i++) {
                if (i < facebookPosts.length) {
                    mixedPosts.push(facebookPosts[i]);
                }
                if (i < instagramPosts.length) {
                    mixedPosts.push(instagramPosts[i]);
                }
            }

            this.list_show = mixedPosts.slice(0, 8);
            this.list_hidden = mixedPosts.slice(8);

            this.hidePreloader();

            if (document.documentElement.classList.contains('mobile')) {
                let scr = document.querySelectorAll('.c-newsfb2__scroll');
                for (let i = 0; i < scr.length; i++) {
                    scr[i].style.webkitAnimationPlayState = "running";
                }
            }

        }).catch(error => {
            console.error('Błąd ', error);
        });

        // this.request(this.url, function( data ) {
        //     let count = 0;
        //     for (let i = 0; data.length > i; ++i) {
        //         ++count;
        //         if (count < 5) {
        //             that.list_show.push(data[i]);
        //         } else {
        //             that.list_hidden.push(data[i]);
        //         }
        //     }
        //     that.hidePreloader();
        //
        //     if (document.documentElement.classList.contains('mobile')) {
        //         let scr = document.querySelectorAll('.c-newsfb2__scroll');
        //         for (let i = 0; i < scr.length; i++) {
        //             scr[i].style.webkitAnimationPlayState = "running";
        //         }
        //     }
        // });
    },
    methods: {
        hidePreloader: function() {
            document.getElementsByClassName('lds-ripple-fb')[0] ?
                document.getElementsByClassName('lds-ripple-fb')[0].style.display = 'none' : false;
        },
        request: function (url, callback) {
            var request = new XMLHttpRequest();

            request.open('GET', url, true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    callback(JSON.parse(this.response))
                }
            };
            request.send();
        }
    },

})
